import { render, staticRenderFns } from "./ShowMainComponent.vue?vue&type=template&id=a14d2b5c"
import script from "./ShowMainComponent.vue?vue&type=script&lang=js"
export * from "./ShowMainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports